import defaultAttributes from '../defaultAttributes';

const MousePointer2 = [
  'svg',
  defaultAttributes,
  [['path', { d: 'm4 4 7.07 17 2.51-7.39L21 11.07z' }]],
];

export default MousePointer2;
